export default __webpack_public_path__ + "static/media/GoogleMapMaker.8c5b220b.bin";